import styled from 'styled-components';

export const HEADING_AND_MESSAGES_STYLE = (base) => ({
  ...base,
  color: 'var(--ds-text-subtlest, var(--ds-fb-text-subtlest))',
});

export const TestTypeMultiSelectStyled = styled.div<{ minWidth?: number }>`
  max-width: 600px;
  min-width: ${(props) => (props.minWidth ? `${props.minWidth}px` : '200px')};
`;

export const TestTypeOptionWithIconStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TestTypeOptionIconStyled = styled.div<{
  backgroundColor: string;
}>`
  background-color: ${(props) => props.backgroundColor};
  border-radius: 24px;
  margin-right: 5px;
  height: 20px;
  min-width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TestTypeOptionLabelStyled = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
